import { c as _c } from "react/compiler-runtime";
import { useSubscription } from '@/context/SubscriptionProvider';
import { useCurrentUserRole } from '@/context/UserRoleProvider';
import { ReactNode } from 'react';
import { Header } from './Header';
import { MobileBottomNav } from './MobileBottomNav';
import { OnboardingChecklist } from './OnboardingChecklist';
import { TopBar } from './TopBar';
type MobileLayoutProps = {
  children: ReactNode;
  hideNav?: boolean;
};
const MobileLayout = t0 => {
  const $ = _c(9);
  const {
    children,
    hideNav: t1
  } = t0;
  const hideNav = t1 === undefined ? false : t1;
  const {
    hasActiveSubscription,
    loading
  } = useSubscription();
  const {
    isInternalUser,
    isLoading: isRoleLoading
  } = useCurrentUserRole();
  const isDev = process.env.NEXT_PUBLIC_ENV === "dev" || process.env.NEXT_PUBLIC_ENV === "local";
  const showNav = !hideNav && (loading || isRoleLoading || hasActiveSubscription || isInternalUser || isDev);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="px-3 pb-2 flex flex-col gap-1.5" style={{
      paddingTop: "max(env(safe-area-inset-top), 0.5rem)"
    }}><TopBar /><Header /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children) {
    t3 = <main className="flex-1 relative min-h-0 overflow-auto h-full bg-white flex flex-col"><div className="flex-1 min-h-0 overflow-auto">{children}</div></main>;
    $[1] = children;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showNav) {
    t4 = showNav && <MobileBottomNav />;
    $[3] = showNav;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OnboardingChecklist />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4) {
    t6 = <div className="flex flex-col h-dvh overflow-hidden p-0 gap-0">{t2}{t3}{t4}{t5}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export { MobileLayout };